import React, { SyntheticEvent } from "react";

import { AlertColor, Alert as MuiAlert, Snackbar } from "@mui/material";

interface DisplayToastAlertProps {
  message: string;
  open: boolean;
  severity: AlertColor;
  onClose: (
    event?: Event | SyntheticEvent<unknown, Event>,
    reason?: string,
  ) => void;
  autoHideDuration?: number;
}

const SUCCESS_SNACKBAR_DURATION = 7000;
const ERROR_SNACKBAR_DURATION = 10000;

/**
 * This Toast defaults to the bottom right. Extend with position props if needed
 **/
export const DisplayToastAlert = ({
  message,
  open,
  severity,
  onClose,
  autoHideDuration,
}: DisplayToastAlertProps) => {
  const duration =
    autoHideDuration ??
    (severity === "error"
      ? ERROR_SNACKBAR_DURATION
      : SUCCESS_SNACKBAR_DURATION);

  return (
    <Snackbar
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      open={open}
      autoHideDuration={duration}
      onClose={onClose}
      data-testid="toast-alert"
    >
      <MuiAlert
        elevation={6}
        variant="filled"
        onClose={onClose}
        severity={severity}
      >
        {message}
      </MuiAlert>
    </Snackbar>
  );
};
